import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from 'src/ui/common/atoms/grid';
import { Spacing } from 'src/ui/common/atoms/spacing';
import { SvgIcon } from 'src/ui/common/atoms/svg-icon';
import { Typography } from 'src/ui/common/atoms/typography';
import { StyledItemWrapper, StyledTextWrapper, StyledTitleWrapper, StyledWrapper } from './styles';

const calendarEvents = [
    {
        date: 'February • 2024',
        events: [
            'GRAND OPENING — February 23, 5 — 8 PM, TECH CONTEMPORARY',
            'Tordenskjoldsgade 21 ST TH,  1055 Copenhagen K',
            'Join us for the grand opening of Denmark’s pioneering digital art gallery.',
            'Experience boundless creativity as DVK the Artist unveils the captivating Ctrl+Alt+Create collection. Witness classical figures in Renaissance attire engaging with computers, transcending aesthetic to explore the profound Digital Freedom Fight.  Drawing inspiration from the Renaissance’s cultural  revival, this exhibition delves into how technology reshapes our modern era, empowering individuals  and breaking down barriers. ' +
                'We look forward to seeing you',
        ],
    },
];
export const CalendarContainer = () => {
    const { t } = useTranslation(['tech-contemporary']);

    const locale = useMemo(
        () => ({
            title: t('calendar.title', { ns: 'tech-contemporary' }),
            addEvent: t('calendar.addEvent', { ns: 'tech-contemporary' }),
        }),
        [t]
    );

    const itemsGridConfig = useMemo(
        () => ({
            xs: 1,
            sm: 2,
        }),
        []
    );

    return (
        <StyledWrapper>
            <Spacing mb="32px">
                <Typography variant="title" size="md" color="white">
                    {locale.title}
                </Typography>
            </Spacing>

            <Grid columnGap={24} rowGap={24} {...itemsGridConfig}>
                {calendarEvents.map((eventGroup) => (
                    <StyledItemWrapper key={eventGroup.date} flexDirection="column">
                        <StyledTitleWrapper>
                            <SvgIcon variant="regular" icon="calendar" color="#B2B6B5" width={16} height={16} />
                            <Typography color="gs100" variant="text" size="xs">
                                {eventGroup.date}
                            </Typography>
                        </StyledTitleWrapper>
                        <StyledTextWrapper>
                            {eventGroup.events.map((event) => (
                                <li key={event}>
                                    <Typography medium variant="text" size="sm" color="lightGrey">
                                        {event}
                                    </Typography>
                                </li>
                            ))}
                        </StyledTextWrapper>
                    </StyledItemWrapper>
                ))}
            </Grid>
        </StyledWrapper>
    );
};